import styles from './HaveInventory.module.css'
import GiftItem from "../GiftItem/GiftItem.tsx";
import GiftModal from "../GiftModal/GiftModal.tsx";
import {useModalStore} from "../../../store/ModalStore.ts";
import {useCallback, useEffect, useRef, useState} from "react";
import Loader from "../../../components/Loader/Loader.tsx";

interface IProfile {
    inventory: {
        items: {
            currency: string,
            amount: number,
            name: string,
            price: number,
            image: string
        }[]
    },
    loadMore: () => void;
    hasMore: boolean;
}

const HaveInventory = ({inventory, loadMore, hasMore}:IProfile) => {

    const setOpen = useModalStore((state) => state.setOpen)

    const [itemImg, setItemImg] = useState<string>();
    const [itemAmount, setItemAmount] = useState<number>();
    const gridRef = useRef<HTMLDivElement>(null);

    const opeModal = (image: string, amount: number) => {
        setOpen(true);
        setItemImg(image);
        setItemAmount(amount)
    }

    const handleScroll = useCallback(() => {
        if (gridRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = gridRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 5 && hasMore) {
                loadMore();
            }
        }
    }, [loadMore, hasMore]);

    useEffect(() => {
        const gridElement = gridRef.current;
        if (gridElement) {
            gridElement.addEventListener('scroll', handleScroll);
            return () => {
                gridElement.removeEventListener('scroll', handleScroll);
            };
        }
    }, [handleScroll]);

    return (
        <div className={styles.inventorySection}>
            <div className={styles.inventoryTitle}>
                Инвентарь
            </div>
            <div className={styles.inventoryGrid} ref={gridRef}>
                {inventory.items.map((item, i) => {
                        return (
                            <GiftItem img={item.image} amount={item.amount} openModal={() => opeModal(item.image, item.amount)} key={i}/>
                        )
                    }
                )}
                {hasMore && <div className={styles.loaderContainer}><Loader/></div>}
            </div>
            {itemImg && itemAmount && <GiftModal img={itemImg} amount={itemAmount}/>}
        </div>
    )
}

export default HaveInventory